export default {"src":"/_next/static/media/suggestions-icon.9fd24493.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};